import api from './../libs/api';

export default {
  getReturns: (params = {}) => {
    return new Promise((resolve, reject) => {
      api()
        .get('/returns', { params })
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  getReturn: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/returns/${id}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  requestReturn: (purchaseId, reason) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`/purchases/${purchaseId}/return`, { return_reason: reason })
        .then(({ status, data }) => {
          if (status === 201) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  updateReturn: (returnId, data) => {
    return new Promise((resolve, reject) => {
      api()
        .put(`/returns/${returnId}`, data)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  }
}; 